export default "__VITE_ASSET__4b33e73c__"